import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";
import { PopupType } from "../popups/popupType";
import {EstimatePrintPopupParams} from "../../components/estimate-print-popup/estimate-print-popup";

export class PrintEstimateCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.PrintEstimate;

    canExecute = ko.computed(() => {
        return !!this.app.state.estimate();
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(data: { id?: number, name: string }): JQueryPromise<any> {
        let estimateId = null;
        let name =  null;
        
        if(data) {
            estimateId = data.id;
            name =  data.name;
        }
        
        if(!estimateId && this.canExecute()){
            let estimate = this.app.state.estimate();
            estimateId = estimate!.id();
            name = estimate!.name()
        }

        let dfd = $.Deferred();

        if (!estimateId)
            return dfd.reject().promise();
        
        this.app.popupsManager.show<EstimatePrintPopupParams>(PopupType.printEstimate, false, {
            estimateId: estimateId!,
            name: name!
        })
            .then(() => {
            dfd.resolve();
        });

        return dfd.promise();
    }

    name = "Export";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/printEstimateCommand.ts